import { iPartialFormData, iExistingForm } from '@interfaces/interfaces';

const { REACT_APP_SITECORE_API_ENDPOINT: API_URL } = process.env;

const PARTIAL_FORMS_API = `${API_URL}sitecore/PartialForms/`;

export const savePartialForm = async (partialForm: iPartialFormData): Promise<boolean> => {
  const url = `${PARTIAL_FORMS_API}UpdatePartialForm`;
  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(partialForm),
  });
  if (response.status !== 200) {
    return false;
  }
  return true;
};

export const createPartialForm = async (partialForm: iPartialFormData): Promise<boolean> => {
  const url = `${PARTIAL_FORMS_API}CreatePartialForm`;
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(partialForm),
  });
  if (response.status !== 200) {
    throw new Error(response.toString());
  }
  return true;
};

export const submitSavedPartialForm = async (pFormId: string): Promise<boolean> => {
  const url = `${PARTIAL_FORMS_API}SubmitSavedPartialForm`;
  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
        partialFormID: pFormId
      }),
  });
  if (response.status !== 200) {
    throw new Error(response.toString());
  }
  return true;
};

export const checkExistingForm = async (obligationNumber: string, formType: string): Promise<iExistingForm> => {
  const url = `${PARTIAL_FORMS_API}CheckingExistingForm`;
  const payload = {
    ObligationNO: obligationNumber,
    formType,
  };
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
  if (response.status !== 200) {
    throw new Error(response.toString());
  }
  const results = await response.json();
  return results;
} catch (error) {
  return {
    CheckingExisting: 'no',
    CanSave: false,
    ExpiryDate: ''
  };
}
};

export const getPartialForm = async (partialFormID: number): Promise<iPartialFormData> => {
  const url = `${PARTIAL_FORMS_API}GetPartialForm`;
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ partialFormID }),
    });
    return response.json();
  } catch (ex) {
    return <iPartialFormData>{};
  }
};
